let functions = {}

const uniq = a => {
  return Array.from(new Set(a))
}
Object.assign(functions, { uniq })

module.exports = functions
